import { ButtonType, ButtonWidget } from '@tableau/widgets';
import React from 'react';

import { Messages } from '~src/codegen/Localize';
import { imgPath } from '~src/commonInfra/utils/ImgUrl';

export type DeleteDomainButtonProps = Readonly<{
    onClick: () => void;
}>;

export function DeleteDomainButton(props: DeleteDomainButtonProps) {
    return (
        <ButtonWidget
            testId="delete-domain-button"
            buttonType={ButtonType.Icon}
            onClick={props.onClick}
            title={Messages.bridgeSiteSettingsDeleteDomain()}
            aria-label={Messages.bridgeSiteSettingsDeleteDomain()}
        >
            <img src={imgPath('trash_14px_small.svg')} alt={''} aria-hidden={true} />
        </ButtonWidget>
    );
}
